import _styled2 from "styled-components";
import _styled from "styled-components";
import React from 'react';
import styled from 'styled-components';
import { Flex, Box } from '@latitude/box';
import { COLOR } from '@latitude/core/utils/constants';
import { Text } from '@latitude/text';
var StyledText = /*#__PURE__*/styled(Text).withConfig({
  displayName: "Banner__StyledText",
  componentId: "sc-1essx7s-0"
})(["padding-left:10px;line-height:1.45;"]);
export var Banner = function Banner(_ref) {
  var children = _ref.children,
      onClose = _ref.onClose,
      showClose = _ref.showClose;
  return /*#__PURE__*/React.createElement(_StyledBox, {
    backgroundColor: COLOR.PINK,
    padding: "20px 0"
  }, /*#__PURE__*/React.createElement(Flex, {
    isResponsive: true,
    alignItems: "center",
    margin: "0 auto"
  }, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "20",
    height: "20",
    viewBox: "0 0 20 20" // css="width:20px; min-width:20px;"
    ,
    style: {
      width: 20,
      minWidth: 20
    }
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M9 13h2v2H9v-2zm0-8h2v6H9V5zm.99-5C4.47 0 0 4.48 0 10s4.47 10 9.99 10C15.52 20 20 15.52 20 10S15.52 0 9.99 0zM10 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
  })), /*#__PURE__*/React.createElement(StyledText, {
    color: COLOR.WHITE
  }, children), showClose && /*#__PURE__*/React.createElement(_StyledButton, {
    type: "button",
    className: "banner-button-close",
    "aria-label": "Close",
    onClick: onClose
  }, /*#__PURE__*/React.createElement("div", {
    "aria-hidden": "true"
  }, "\xD7"))));
};

var _StyledBox = /*#__PURE__*/styled(Box).withConfig({
  displayName: "Banner___StyledBox",
  componentId: "sc-1essx7s-1"
})(["position:relative;z-index:3;"]);

var _StyledButton = /*#__PURE__*/styled("button").withConfig({
  displayName: "Banner___StyledButton",
  componentId: "sc-1essx7s-2"
})(["color:#fff;font-size:30px;margin:0;padding:0 5px;"]);